import { useContext, useEffect, useState } from "react";
import { IGenericObject } from "shared/programs/migration-acceleration-program/2024/fund-request/types/CommonTypes";
import { NotificationsContext } from "shared/util/context/notifications/NotificationsContext";
import { getApprovalAutomationResult } from "internal/util/services/aiba/AIBAService";
import { hasError } from "shared/util/services/data/DataService";
import { GENERIC_ERROR_MESSAGE } from "external/programs/migration-acceleration-program/2024/fund-request/components/create/wizard/Steps/Artifacts/util";

import { Container, SpaceBetween, Header } from "@amzn/awsui-components-react";
import ReportTabs from "./report/ReportTabs";
import SummarySection from "./summary/SummarySection";

const CalcBusterResult = () => {
  const [response, setResponse] = useState<IGenericObject | null>(null);
  const { addNotification } = useContext(NotificationsContext);
  const fetchResult = async () => {
    try {
      const result = await getApprovalAutomationResult();
      if (hasError(result)) {
        addNotification({
          content: GENERIC_ERROR_MESSAGE,
          type: "error",
        });
        return;
      }
      if (result !== undefined) {
        setResponse(result);
      }
    } catch (e) {
      addNotification({
        content: GENERIC_ERROR_MESSAGE,
        type: "error",
      });
    }
  };

  useEffect(() => {
    fetchResult();
  }, []);

  if (!response || !response["calcbusterResults"]) {
    return null; // Do not render the component if missing fields
  }

  return (
    // P1: add ability to side scroll for multiple each CalcBuster result
    <Container header={<Header variant="h2">CalcBuster analysis</Header>}>
      {response["calcbusterResults"].length !== 0 ? (
        <SpaceBetween size="l">
          <SummarySection item={response["calcbusterResults"][0]} />
          <ReportTabs item={response["calcbusterResults"][0]} />
        </SpaceBetween>
      ) : (
        // If CalcBuster analysis is enabled but no estimates are attached
        <SpaceBetween size="l">No Pricing Calculator Estimates</SpaceBetween>
      )}
    </Container>
  );
};

export default CalcBusterResult;
